// removed by extract-text-webpack-plugin
module.exports = {"mainSliderContainer":"mainSliderContainer__2yWwc","bannerImgOuterContainer":"bannerImgOuterContainer__1uonP","bannerImgContainer":"bannerImgContainer__NlJca","lightboxContainer":"lightboxContainer__3P6NW","videoFrame":"videoFrame__1agmw","closeAction":"closeAction__2jnPO","arrowSize":"arrowSize__1QNs8","educationalModalDialogBody":"educationalModalDialogBody__3JbXM","closeEducationalModal":"closeEducationalModal__3vDYA","educationModalDialog":"educationModalDialog__f6Wgm"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/common/eduModalDialog/style.css
// module id = izT8
// module chunks = 323